/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import { List } from "immutable";
import { TeaserStatItem } from "../../records/teaser_list";
import * as constants from "../../constants/teaserList";
import { CLOSE_POPUP } from "../../constants";

function isOpen(state = false, action) {
  if (action.type == constants.OPEN_STAT_POPUP) {
    return true;
  }
  if (action.type == CLOSE_POPUP) {
    return false;
  }
  return state;
}

function teaser(state = { id: undefined }, action) {
  if (action.type == constants.OPEN_STAT_POPUP) {
    return { id: action.id };
  }
  if (action.type == CLOSE_POPUP) {
    return { id: undefined };
  }
  return state;
}

function daily(state = new List(), action) {
  if (action.type == constants.ON_LOAD_TEASER_STAT) {
    return new List(action.daily).map(stat => new TeaserStatItem(stat));
  }
  return state;
}

function summary(state = new TeaserStatItem(), action) {
  if (action.type == constants.ON_LOAD_TEASER_STAT) {
    return new TeaserStatItem(action.summary);
  }
  return state;
}

export default combineReducers({
  isOpen,
  teaser,
  daily,
  summary
});
